import modelsResolver from 'utils/api/models/utils/modelsResolver';

export interface IInstallment {
	productOfferId?: number;
	duration: number;
}

export interface ISmartVoucher {
	commitmentDuration: number;
	deviceDiscount: number;
	upFrontPayment: number;
	installments: IInstallment[];
}

export interface ISmartVouchersResponse {
	vouchers: ISmartVoucher[];
}

const model: types.models.InputModel = {
	_data: 'response',
	vouchers: (model: any) => model._data.map((voucher: any) => modelsResolver(voucher, 'singleVoucher')),
};

export default model;
